import styled from 'styled-components';
import { Accordion } from 'react-bootstrap';

export const StyledAccordion = styled(Accordion)`
    .accordion-button {
        color: #1e293b;
        font-weight: 600;
        background-color: transparent;
        box-shadow: none;
        padding: 1rem 1.25rem;
        
        &:not(.collapsed) {
            color: #821692;
            background-color: #fdf4ff;
        }
        
        &:focus {
            box-shadow: none;
            border-color: rgba(130, 22, 146, 0.1);
        }
    }
    .accordion-body {
        padding: 1.5rem;
        background-color: #fff;
    }
    .accordion-item {
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        margin-bottom: 0.5rem;
        overflow: hidden;
    }
`;
